import { COLOR_FILTERS_STATUS, type ReportData } from '@ipfabric/utils';
import type { ApiTableCommandFactory } from 'components/ApiTable/model/ApiTableModel';
import { reloadTableDataInViewport } from './reloadTableDataInViewport';
import { updateTableReports } from './updateTableReports';

/**
 * Handle update of color filter reports
 *
 * Save reports to state and reload table data if any of reports has changed status but
 * don't reload if all reports are still running to prevent repeated reloads/requests
 */
export const handleColorFilterUpdate: ApiTableCommandFactory<{
  data: ReportData[];
}> =
  (cmdContext, dispatch) =>
  ({ data }) => {
    const { reports } = cmdContext.getState();
    const isStatusOfReportChanged = (report: ReportData) =>
      !reports[report.column] ||
      report.status !== reports[report.column]?.status;
    const reloadTable = data.some(
      (report) =>
        report.status !== COLOR_FILTERS_STATUS.run &&
        isStatusOfReportChanged(report),
    );
    dispatch(updateTableReports, { data });
    if (reloadTable) {
      dispatch(reloadTableDataInViewport);
    }
  };
